import React, { useState } from 'react';
import { sendEmailVerification, signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleResend = async () => {
    try {
      await sendEmailVerification(auth.currentUser);
      setMessage('📧 Email di verifica inviata! Controlla la tua casella.');
    } catch (error) {
      setMessage("Errore durante l'invio della verifica. Riprova.");
    }
  };

  const handleReload = async () => {
    try {
      await auth.currentUser.reload();
      if (auth.currentUser.emailVerified) {
        //window.location.reload(); // oppure navigate a dashboard
        navigate('/dashboard');
      } else {
        setMessage('Email ancora non verificata.');
      }
    } catch (error) {
      console.error('Errore nel ricaricamento:', error);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 p-6">
      <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow">
        <h2 className="mb-4 text-2xl font-semibold text-gray-800">
          Verifica il tuo indirizzo email
        </h2>
        <p className="mb-4 text-gray-600">
          Ti abbiamo inviato un’email per verificare il tuo account. Clicca sul link ricevuto per
          continuare.
        </p>

        {message && <div className="mb-4 text-sm text-blue-700">{message}</div>}

        <button
          disabled={auth.currentUser.emailVerified}
          onClick={handleResend}
          className="mb-3 w-full rounded bg-blue-600 px-4 py-2 text-white transition hover:bg-blue-700"
        >
          📤 Invia di nuovo la verifica
        </button>

        <button
          onClick={handleReload}
          className="mb-3 w-full rounded border border-gray-400 px-4 py-2 text-gray-700 transition hover:bg-gray-100"
        >
          🔄 Ho verificato, aggiorna
        </button>

        <button onClick={handleLogout} className="w-full text-sm text-red-500 hover:underline">
          Esci
        </button>
      </div>
    </div>
  );
};

export default VerifyEmail;
